import { RichTypeBoolean } from "../../flowGraphRichTypes.js";
import { FlowGraphExecutionBlock } from "../../flowGraphExecutionBlock.js";
/**
 * @experimental
 * A block that evaluates a condition and executes one of two branches.
 */
export class FlowGraphConditionalBlock extends FlowGraphExecutionBlock {
    constructor() {
        super();
        this.condition = this._registerDataInput("condition", RichTypeBoolean);
        this.onTrue = this._registerSignalOutput("onTrue");
        this.onFalse = this._registerSignalOutput("onFalse");
    }
    _execute(context) {
        if (this.condition.getValue(context)) {
            this.onTrue._activateSignal(context);
        }
        else {
            this.onFalse._activateSignal(context);
        }
    }
}
//# sourceMappingURL=flowGraphConditionalBlock.js.map